// Used as vuex store module path
const MODULE_ID = 'unfalldesk';
export default MODULE_ID;
